export default {"src":"/_next/static/media/post-exploitation.c8fc724f.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};